// ©2024 Austin App House. All rights reserved.
import React, { useContext, useState } from "react";
import { MDBTooltip } from "mdbreact";
import { SocketContext } from "../../../pages";

const MessageSticker = ({ message, userId, sendMessage, fetchConversation, replyAvailable = true, isReply = false }) => {
    const { chatSocket: socket } = useContext(SocketContext) ?? {};
    const [showReply, changeShowReply] = useState(false);
    const [replyMessage, setReplayMessage] = useState(null);

    const submitReply = (event) => {
        event.preventDefault();
        sendMessage(replyMessage, message._id);
        fetchConversation(socket);
        setReplayMessage('');
        changeShowReply(false);
    };

    const isMyMessage = userId === message.fromId.id;
    const recipients = message.toId.filter(el => el._id !== message.fromId.id);

    return (
        <div className={'msg_section'}>
            <div className="msg_list">
                <div className={`msg_item`}>
                    <div className={`msg_to ${isReply ? 'msg_to light' : 'msg_to dark'}`}>
                        <div className='msg_header'>
                            <label>
                                {message.fromId.firstName + ' ' + message.fromId.lastName}
                                <MDBTooltip domElement tag="span" placement="top">
                                    <span className="msg_user">{recipients.length > 0 ? ` + ${recipients.length} others` : ''}</span>
                                    <span className="msg_date">
                                        {recipients.map((el, index) => <span key={index}>{el.firstName + ' ' + el.lastName}<br /></span>)}
                                    </span>
                                </MDBTooltip>
                            </label>
                            <label>{new Date(message.sentAt).toLocaleString()}</label>
                        </div>
                        <div className="msg_body">
                            <div className="msg_text">{message.messageContent}</div>
                            {replyAvailable && !isReply &&
                                <button className="reply_btn" onClick={() => changeShowReply(!showReply)}>Reply</button>
                            }
                        </div>
                    </div>

                    {message.children?.length ? message.children.map(child => (
                        <MessageSticker
                            key={child._id}
                            message={child}
                            isReply={true}
                            replyAvailable={false}
                        />
                    )) : message.children?.messageContent ? <MessageSticker
                        key={message.children._id}
                        message={message.children}
                        isReply={true}
                        replyAvailable={false}
                    /> : null}

                    {showReply &&
                        <form className='field_block content modal_footer' onSubmit={submitReply}>
                            <input
                                type='text'
                                name='text'
                                value={replyMessage}
                                onChange={(e) => setReplayMessage(e.target.value)}
                            />
                            <button
                                type='submit'
                                className="reply_btn "
                            >
                                Reply
                            </button>
                        </form>
                    }
                </div>
            </div>
        </div>
    );
}

export default MessageSticker;
